var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResourceRichlibrary01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 101 101",
    style: {
      enableBackground: "new 0 0 101 101"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0E98B4;stroke:#0E98B4;stroke-width:0.5;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 45.6,
    y: 33.7,
    className: "st0",
    width: 9.8,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.6,
    y: 57.6,
    className: "st0",
    width: 9.8,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.6,
    y: 81.5,
    className: "st0",
    width: 9.8,
    height: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.8,5.7v16H59.5l4.6-1.9L57.3,3.6l-4.9,2.1l6.7,16H17.2V4.6h-1.3v17.1v0.7v23.3V47v22.6v1.3v23.9h3.8v2.5 h0.9v-2.5h60.7v2.5h0.9v-2.5h2.9V70.9v-1.3V47v-1.3V23.5v-1.8v-16C85.1,5.7,83.8,5.7,83.8,5.7z M54.2,6.4l2.5-1L62.4,19l-2.5,1 L54.2,6.4z M83.8,93.5H17.2V70.9h66.5C83.8,70.9,83.8,93.5,83.8,93.5z M83.8,69.6H17.2V47h66.5C83.8,47,83.8,69.6,83.8,69.6z  M83.8,23.5v22.2H17.2V23h66.5C83.8,23,83.8,23.5,83.8,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.8,4h-5.3v17.5h5.3V4z M23.5,20.1h-2.7V5.3h2.7V20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.2,4h-5.3v17.5h5.3V4z M29.9,20.1h-2.7V5.3h2.7V20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.6,4h-5.3v17.5h5.3V4z M36.3,20.1h-2.7V5.3h2.7V20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.1,4h-5.3v17.5h5.3V4z M42.7,20.1H40V5.3h2.7V20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.5,4h-5.3v17.5h5.3V4z M49.2,20.1h-2.7V5.3h2.7V20.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceRichlibrary01);
export default __webpack_public_path__ + "static/media/ResourceRichlibrary-01.e12c8b70d8f5de5627cd8c19b71925c5.svg";
export { ForwardRef as ReactComponent };